<template>
  <Modal class="file-input-selector-modal">
    <div class="file-input-selector-header">
      <h5>เลือกไฟล์แนบ</h5>
      <button
        type="button"
        class="btn-close"
        @click.stop="setActiveModal(null)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="file-input-selector-container">
      <div
        class="file-input-selector selector--fromLocal"
        @click.stop="$refs.file.click()">
        <i class="fas fa-upload"></i>
        <p>อัปโหลดไฟล์จากคอมพิวเตอร์</p>
      </div>
      <div
        class="file-input-selector selector--fromServer"
        @click.stop="setActiveModal('ChooseExistingFilesModal')">
        <i class="fas fa-folder-open"></i>
        <p>เลือกไฟล์ที่มีในระบบ</p>
      </div>
    </div>
    <input
      class="hidden-input"
      type="file"
      ref="file"
      @change="onSelectFilesToUpload"
      multiple>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import attachmentMixin from './attachmentMixin';

export default {
  mixins: [attachmentMixin],
  components: {
    Modal,
  },
  methods: {
    ...mapActions(['setActiveModal']),
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.hidden-input {
  display: none;
}

.file-input-selector-modal {
  .file-input-selector-header {
    padding: 20px 0 0 20px;
    background: $gray-200;
    .btn-close {
      z-index: 100;
      position: absolute;
      top: 16px;
      right: 10px;
      background: transparent;
      border: none;
      outline: none;
      transition: color 250ms ease;
      color: $gray-700;
      &:hover {
        color: $red;
      }
    }
  }
  .file-input-selector-container {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;

    .file-input-selector {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      width: 50%;
      padding: 30px 0;
      transition: all 250ms ease;

      i {
        font-size: 60px;
        margin: 10px 0;
      }

      &:hover {
        background: $gray-200;
      }
    }

    .selector--fromLocal {
      border-right: 1px dashed $gray-400;
    }
  }
}

@media screen and (max-width: 575.98px) {
  .file-input-selector-modal {
    .file-input-selector-container {
      flex-flow: column;
      .file-input-selector {
        width: 100%;
        padding: 10px 0;
      }
      .selector--fromLocal {
        border-right: none;
        border-bottom: 1px dashed #ced4da;
      }
    }
  }
}
</style>
